export const iconFontAwesomeArrowsDownLong = (
	<i className="fa-solid fa-down-long"></i>
);
